import React, {Component} from 'react';
import Card from 'react-bootstrap/Card';
const $ = require('jquery');
const jzip = require('jzip');
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'เลขใบงาน',
    data: 'planid',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.planStatus ? row.planid : row.planid.substring(0, 4)+"**********"+row.planid.substring(14, 16);
      }
      return data;
    }
  },
  {
    title: 'วันที่เดินทาง',
    data: 'date_start',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === "travel" ? row.date_start : row.system === "recost" ? `<input class="btn btn-outline-success btn-xs m-1" type="button" value="โยกงบรายเดือน" disabled id="cc-${row.planid}">` : "อื่นๆ";
      }
      return data;
    }
  },
  {
    title: 'ประเภท',
    data: 'typeName',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === "travel" ? row.typeName : row.system === "recost" ? `<input class="btn btn-outline-primary btn-xs m-1" type="button" value="${row.budget[0].costCenterName}" disabled id="cc-${row.planid}">` : "อื่นๆ";
      }
      return data;
    }
  },
  {
    title: 'จุดประสงค์',
    data: 'objectiveShort',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === "travel" ? row.objectiveShort : row.system === "recost" ? `<input class="btn btn-outline-secondary btn-xs m-1" type="button" value="${row.budget.reduce((prev,curr)=>(prev + Number(curr.costRemain.replaceAll(',', ''))),0)}" disabled id="cc-${row.planid}">` : "อื่นๆ";
      }
      return data;
    }
  },
  {
    title: 'รหัสพนักงาน',
    data: 'staffid'
  },
  {
    title: 'ผู้ขอ',
    data: 'staff'
  },
  {
    title: '',
    data: 'planid',
    render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        if (row.enableShortcut) {
          return `<input class="btn btn-primary btn-xs m-1" type="button" value="อนุมัติ" id="a-${data}"><input class="btn btn-danger btn-xs m-1" type="button" value="ไม่อนุมัติ" id="r-${data}">`;
        } else {
          if (row.status === '')
            return `<input class="btn btn-primary btn-xs m-1" type="button" value="on process" disabled id="cp-${data}">`;
          if (row.status === 'approve')
            return `<input class="btn btn-success btn-xs m-1" type="button" value="complete" disabled id="cp-${data}">`;
          if (row.status === 'reject')
            return `<input class="btn btn-danger btn-xs m-1" type="button" value="rejected" disabled id="rj-${data}">`;
          if (row.status === 'cancel')
            return `<input class="btn btn-warning btn-xs m-1" type="button" value="cancelled" disabled id="cc-${data}">`;
        }
      }
      return data;
    }
  },
  {
    title: 'View',
    data: 'planid',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<a class="btn btn-outline-secondary btn-sm" id="${row.planid}_view"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  },
  {
    title: 'Print',
    data: 'planid',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.planStatus && row.system === "travel" ? `<a class="btn btn-outline-secondary btn-sm" id="${row.planid}_print"><i class="fas fa-print" /></a>` : `<a class="d-none"/></a>`;
      }
      return data;
    }
  },
  {
    title: 'QR',
    data: 'planid',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.planStatus && row.system === "travel" ? `<a class="btn btn-outline-secondary btn-sm" id="${row.planid}_qr"><i class="fas fa-qrcode" /></a>` : `<a class="d-none"/></a>`;
      }
      return data;
    }
  }
];

function reloadTableData(items, page) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  //   const table = $(`table.example`).DataTable();
  table.clear();
  table.rows.add(items);
  table.draw();
  table.page(page).draw('page');
}

function updateTable(items, page) {
  console.log('update: ' + items.length);
  const table = $(`#${0}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = items.find((item) => {
      return item.planid === oldNameData.planid;
    });

    if (oldNameData.lastUpdate !== newNameData.lastUpdate) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  console.log(dataChanged);
  if (dataChanged) {
    //table.draw();
    table.page(page).draw('page');
  }
}

class TableMyItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      scrollX: true,
      scrollCollapse: true, // ถ้าตารางเล็กกว่า scroll container

      fixedColumns: {
        leftColumns: 2,
        rightColumns: 3,
      },
      // responsive: true,
      columnDefs: [
        // {target: 0, responsivePriority: 1},
        // {target: 1, responsivePriority: 2},
        // {target: 2, responsivePriority: 1},
        // {target: 3, responsivePriority: 2},
        // {target: 4, responsivePriority: 2},
        // {targets: -3, responsivePriority: 1},
        // {targets: -2, responsivePriority: 1},
        // {targets: -1, responsivePriority: 1},
        {target: 5, visible: false}
      ],
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_report_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_report_excel_${Date.now()}`
        }
      ]
    });

    $(`#${0} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      if ($this.attr('id').split('_')[1] === 'view'){
        this.props.onToggle(data);
      }else if ($this.attr('id').split('_')[1] === 'print'){
        this.props.onPrintToggle(data);
      }else if ($this.attr('id').split('_')[1] === 'qr'){
        this.props.onQrToggle(data);
      }
    });

    $(`#${0} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      console.log(event.currentTarget.value);
      console.log(data.planid);
      if (event.currentTarget.value === 'อนุมัติ') {
        this.props.onAgree(data.planid);
      } else {
        this.props.onReject(data.planid);
      }
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.items.length !== this.props.items.length) {
      reloadTableData(nextProps.items, nextProps.page);
    // } else {
      // updateTable(nextProps.items, nextProps.page);
    // }
    return true;
  }

  render() {
    return (
      <div>
        <Card className="card-primary">
          <div className={this.props.show ? 'd-none' : 'overlay dark'}>
            <span style={{color: 'white', fontSize: 30}}>CR ONLY</span>
          </div>
          <Card.Header>รายการของคุณทั้งหมด</Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableMyItem;
